<script lang="ts">
	import Input from './Input.svelte';

	type Props = {
		id: string;
		label: string;
		value?: string;
		name: string;
		error: string | string[] | undefined;
		autocomplete?: HTMLInputElement['autocomplete'];
		placeholder?: string | undefined;
		setValue?: (value: string) => void;
	};

	let {
		id,
		label,
		value = '',
		name,
		error,
		autocomplete = 'tel',
		placeholder,
		setValue
	}: Props = $props();

	function handleInput(event: Event) {
		const target = event.target as HTMLInputElement;
		error = undefined;
		setValue?.(target.value);
	}
</script>

<Input {error}>
	<label for={id} class="input-label">{label}</label>
	<input
		{id}
		type="tel"
		{name}
		{value}
		class="w-full"
		{autocomplete}
		{placeholder}
		oninput={handleInput}
	/>
</Input>
